export default __webpack_public_path__ + "img/title-mob-map.png?7e4c";